// removed by extract-text-webpack-plugin
module.exports = {"info-icon":"_1JERd","infoIcon":"_1JERd"};